import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import sha1 from 'js-sha1';

import './ReadReceiptsComponent.scss';
import blocks from '../../blocks';
import elements from '../../elements';
import styled from './styled';

class ReadReceiptsComponent extends React.Component {
  state = {
    readList: [],
    unReaders: [],
    channelMembers: [],
  };

  componentDidMount() {
    this.updateReadUnreadLists();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.allUsers !== this.props.allUsers ||
      prevProps.activePost !== this.props.activePost ||
      prevProps.activeChannel !== this.props.activeChannel
    ) {
      this.updateReadUnreadLists();
    }
  }

  updateReadUnreadLists = () => {
    const { activePost, allUsers, activeChannel } = this.props;
    if (!activePost || !allUsers || !activeChannel) return;

    const readers = allUsers.filter((user) =>
      activePost.readList.includes(user.owner_id)
    );

    const channelUsers = allUsers.filter(
      (user) =>
        user.user &&
        user.status === 'active' &&
        user.user.channel_ids?.includes(activeChannel.id)
    );

    const unReaders = channelUsers.filter(
      (user) => !activePost.readList.includes(user.owner_id)
    );

    this.setState({ readList: readers, channelMembers: channelUsers, unReaders });
  };

  getUserUUID = (userId) => `user.${sha1(`user.${userId}`)}`;

  handleClose = (e) => {
    e.preventDefault();
    this.props.resetActiveSidePane();
  };

  renderUser = (user) => {
    const { onlineUsers = [] } = this.props;
    const isOnline = onlineUsers.includes(this.getUserUUID(user.owner_id));
    const profileUrl = user.profile_image_thumb_url || '/icons/default-profile-thumb.svg';
    const showAdminBadge = user.is_admin;
    const hasPosition = user.position;
    const hasBadge = user.badge_id;

    const bottomLine = hasPosition && hasBadge ? (
      <styled.BottomLineWrap>
        <styled.BottomLineText>{user.position}</styled.BottomLineText>
        <styled.Dot />
        <styled.BottomLineText>{user.badge_id}</styled.BottomLineText>
      </styled.BottomLineWrap>
    ) : (
      <styled.BottomLineTextOneItem>{user.position || user.badge_id || ''}</styled.BottomLineTextOneItem>
    );

    return (
      <styled.MessageWrap key={user.id}>
        <styled.AvatarWrap>
          <styled.ProfileAvatar src={profileUrl} />
          {isOnline && <styled.OnlineMark />}
        </styled.AvatarWrap>
        <styled.InfoWrap>
          <styled.Name>
            {`${user.first_name} ${user.last_name}`}
            {showAdminBadge && <styled.ApprovedBadge src="/icons/verified-badge-icon.svg" />}
          </styled.Name>
          {bottomLine}
        </styled.InfoWrap>
      </styled.MessageWrap>
    );
  };

  render() {
    const { readList, unReaders } = this.state;

    return (
      <elements.ColumnWrap>
        <div className="reader__wrap">
          <p className="reader__title">
            <FormattedMessage id="ReadReceipts.readBy" defaultMessage="Read By" />
          </p>
          <button className="reader__close-button" onClick={this.handleClose} />
        </div>
        <elements.ScrollWrap isLoading={false}>
          <div className="listSeparator">
            <label className="listSeparator__text">
              <FormattedMessage id="ReadReceipts.readLabel" defaultMessage="Read" />
            </label>
            <label className="listSeparator__number">({readList.length})</label>
          </div>
          {readList.map(this.renderUser)}

          <div className="listSeparator">
            <label className="listSeparator__text">
              <FormattedMessage id="ReadReceipts.unreadLabel" defaultMessage="Unread" />
            </label>
            <label className="listSeparator__number">({unReaders.length})</label>
          </div>
          {unReaders.map(this.renderUser)}
        </elements.ScrollWrap>
      </elements.ColumnWrap>
    );
  }
}

ReadReceiptsComponent.propTypes = {
  resetActiveSidePane: PropTypes.func.isRequired,
  allUsers: PropTypes.array.isRequired,
  activePost: PropTypes.object.isRequired,
  activeChannel: PropTypes.object.isRequired,
  onlineUsers: PropTypes.array,
};

export default injectIntl(ReadReceiptsComponent);
